import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M5.25 6.75v-1.5a2.25 2.25 0 0 1 4.5 0v1.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "7.5",
      height: "6",
      x: "3.75",
      y: "6.75",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      rx: "1.2"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.5",
      cy: "9.25",
      r: ".6",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1)
  ]))]))
}
export default { render: render }